import Global from "@/components/Global";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const ChatLogHandler = {
  MyFunction: function(param) {
    alert(param);
  },
  ///Scroll Top 載入舊訊息
  GetHistory: function(messageCount) {
    var messages_ = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetHistory",
      type: "post",
      async: false,
      data: {
        roomId: Global.current_roomid,
        staffId: Global.current_staffid,
        messageCount: messageCount        
      },
      dataType: "json",
      success: function(data) {
        messages_ = data;
      },
      error: function(a, b, c) {
        //window.location.href = "/#/Error";
      }
    });

    return  messages_;
    
  },
  
  
};



// WEBPACK FOOTER //
// ./src/handler/ChatLogHandler.js